var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00583 10.6668C1.00392 10.6668 1.0031 10.6644 1.0046 10.6633L11.7721 2.28852C12.4943 1.72679 13.5057 1.72679 14.2279 2.28851L24.9954 10.6633C24.9969 10.6644 24.9961 10.6668 24.9942 10.6668H22.3333V22.0002C22.3333 23.1047 21.4379 24.0002 20.3333 24.0002H5.66666C4.5621 24.0002 3.66667 23.1047 3.66667 22.0002V10.6668H1.00583Z",
    stroke: "url(#paint0_linear_1742_1698)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1742_1698",
    x1: 33.3692,
    y1: 19.8663,
    x2: 24.1275,
    y2: 31.6932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFill);
export default __webpack_public_path__ + "static/media/home-fill.6648bc46fd008340ada45e10b3130d57.svg";
export { ForwardRef as ReactComponent };